import StatusChip, { statusChipStatus } from "@common/components/statusChip/StatusChip.tsx";
import { setFirstLetterToLowerCase } from "@common/stringOperations.ts";
import { useTranslation } from "@localization/useTranslation";
import { IncidentLogEntryStatus } from "../IncidentLogDialog.types.ts";

export interface IncidentLogStatusChipProps {
    status: IncidentLogEntryStatus;
}

// Archived reuses the colour contracts, systems and legal entities give their end-of-life state, so the overviews
// read the same.
const chipColorByStatus: Record<IncidentLogEntryStatus, statusChipStatus> = {
    [IncidentLogEntryStatus.Draft]: "lightgreen",
    [IncidentLogEntryStatus.Active]: "green",
    [IncidentLogEntryStatus.Archived]: "purple",
};

function IncidentLogStatusChip(props: IncidentLogStatusChipProps) {
    const { translateString } = useTranslation();

    return <StatusChip value={translateString(setFirstLetterToLowerCase(IncidentLogEntryStatus[props.status]))} status={chipColorByStatus[props.status]} />;
}

export default IncidentLogStatusChip;
